import { useState } from "react";
import { useTranslation } from "react-i18next";
import { HiChartBar } from "react-icons/hi2";

import { SidebarNavElement } from "@/components/_templates/sidebar/sidebar-nav-element";
import { makeWorkspaceUrl } from "@/domain/workspace/lib/make-workspace-url";
import { Workspace } from "@/domain/workspace/models/workspace-model";

import { useGetIndicatorListQuery } from "../hooks/api/use-get-indicator-list";

interface IndicatorSidebarNavLinkProps {
  workspace: Workspace;
}

export const IndicatorSidebarNavLink = ({ workspace }: IndicatorSidebarNavLinkProps) => {
  const { t } = useTranslation("common");
  const [hasHovered, setHasHovered] = useState(false);

  useGetIndicatorListQuery({
    workspaceId: workspace.id,
    enabled: hasHovered,
  });

  return (
    <SidebarNavElement
      to={makeWorkspaceUrl({ workspace: workspace, path: "indicators" })}
      onMouseEnter={() => {
        setHasHovered(true);
      }}
    >
      <HiChartBar className="mr-2 h-3 w-3" />
      {t("navigation.indicators")}
    </SidebarNavElement>
  );
};
